let defaultMinPrice = 0;
let defaultMaxPrice = 1000;

document.addEventListener("DOMContentLoaded", function () {
  const checkboxes = document.querySelectorAll(".sp-tag-filters__checkbox");
  const noProductsMessage = document.getElementById("no-products-message");
  const searchInput = document.getElementById("sp-filter-search");
  const inStockCheckbox = document.getElementById("sp-filter-instock");
  const resultsCount = document.getElementById("sp-filter-results-count");
  const clearFiltersButton = document.getElementById("sp-clear-filters");

  const priceMinRange = document.getElementById("sp-price-min");
  const priceMaxRange = document.getElementById("sp-price-max");
  const priceMinInput = document.getElementById("sp-price-min-input");
  const priceMaxInput = document.getElementById("sp-price-max-input");
  const priceRangeProgress = document.getElementById("sp-price-range-progress");
  const priceMinLabel = document.getElementById("sp-price-min-label");
  const priceMaxLabel = document.getElementById("sp-price-max-label"); 
  const activeFiltersContainer = document.getElementById("sp-active-filters");
  const sortSelect = document.getElementById("sp-sort-select");
  if (!checkboxes.length) return;

  const firstProduct = document.querySelector(".product-card-wrapper");
  if (!firstProduct) return;

  const firstGridItem = firstProduct.closest(".grid__item");
  if (!firstGridItem) return;

  const gridContainer = firstGridItem.parentElement;
  if (!gridContainer) return;

  const pagination = document.querySelector(".pagination");

  const originalGridHTML = gridContainer.innerHTML;

  let allProducts = [];
  let allProductsLoaded = false;

  checkboxes.forEach((cb) => {
    cb.checked = false;
  });

  if (searchInput) searchInput.value = "";
  if (inStockCheckbox) inStockCheckbox.checked = false;

  function updateResultsCount(count) {
    if (!resultsCount) return;
    resultsCount.textContent = `${count} card${count === 1 ? "" : "s"} found`;
  }

  function getProductDataFromDocument(doc) {
    const productCards = doc.querySelectorAll(".product-card-wrapper");
    const items = [];

    productCards.forEach((card) => {
      const gridItem = card.closest(".grid__item");
      if (!gridItem) return;

      const titleLink = card.querySelector(".product-grid--title a");
      const titleText = titleLink ? titleLink.textContent.trim() : "";

      const variantPriceAttr = card.dataset.variantPrices || "";
      const variantPrices = variantPriceAttr
        .split(",")
        .map((p) => parseFloat(p))
        .filter((p) => !isNaN(p));

      items.push({
        id: card.dataset.productId || card.getAttribute("data-product-id") || gridItem.outerHTML,
        tags: card.dataset.tags ? card.dataset.tags.split(",") : [],
        title: titleText,
        available: card.dataset.productAvailable === "true",
        variantPrices: variantPrices,
        html: gridItem.outerHTML
      });
    });

    return items;
  }

  function getMaxPage() {
    let maxPage = 1;

    document.querySelectorAll('a[href*="page="]').forEach((link) => {
      try {
        const url = new URL(link.href, window.location.origin);
        const page = parseInt(url.searchParams.get("page"), 10);
        if (!isNaN(page) && page > maxPage) {
          maxPage = page;
        }
      } catch (e) {}
    });

    return maxPage;
  }

function updatePriceProgress() {
  if (!priceMinRange || !priceMaxRange || !priceRangeProgress) return;

  const min = parseFloat(priceMinRange.min);
  const max = parseFloat(priceMinRange.max);
  const minVal = parseFloat(priceMinRange.value);
  const maxVal = parseFloat(priceMaxRange.value);

  if (max <= min) return;

  const leftPercent = ((minVal - min) / (max - min)) * 100;
  const rightPercent = ((maxVal - min) / (max - min)) * 100;

  const thumbOffsetPx = 7;

  priceRangeProgress.style.left =
    `calc(${leftPercent}% + ${thumbOffsetPx}px)`;

  priceRangeProgress.style.width =
    `calc(${rightPercent - leftPercent}% - ${thumbOffsetPx * 2}px)`;

  /* NEW — Floating labels */

if (priceMinLabel) {
  priceMinLabel.textContent =
    `$${minVal.toLocaleString()}`;
}

if (priceMaxLabel) {
  priceMaxLabel.textContent =
    `$${maxVal.toLocaleString()}`;
}
}

  async function loadAllProducts() {
    const productsMap = new Map();

    getProductDataFromDocument(document).forEach((product) => {
      productsMap.set(product.id, product);
    });

    const maxPage = getMaxPage();

    if (maxPage > 1) {
      const requests = [];

      for (let page = 2; page <= maxPage; page++) {
        const url = new URL(window.location.href);
        url.searchParams.set("page", page);

        requests.push(
          fetch(url.toString())
            .then((response) => response.text())
            .then((html) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, "text/html");
              return getProductDataFromDocument(doc);
            })
            .catch(() => [])
        );
      }

      const results = await Promise.all(requests);

      results.flat().forEach((product) => {
        productsMap.set(product.id, product);
      });
    }

    allProducts = Array.from(productsMap.values());
    allProductsLoaded = true;

    const allVariantPrices = allProducts.flatMap((product) => product.variantPrices || []);

    if (allVariantPrices.length) {
      defaultMinPrice = Math.floor(Math.min(...allVariantPrices));
      defaultMaxPrice = Math.ceil(Math.max(...allVariantPrices));

      if (priceMinRange) {
        priceMinRange.min = defaultMinPrice;
        priceMinRange.max = defaultMaxPrice;
        priceMinRange.value = defaultMinPrice;
      }

      if (priceMaxRange) {
        priceMaxRange.min = defaultMinPrice;
        priceMaxRange.max = defaultMaxPrice;
        priceMaxRange.value = defaultMaxPrice;
      }

      if (priceMinInput) {
        priceMinInput.value = defaultMinPrice;
      }

      if (priceMaxInput) {
        priceMaxInput.value = defaultMaxPrice;
      }

      updatePriceProgress();
    }

    if (
      !searchInput?.value &&
      !inStockCheckbox?.checked &&
      !Array.from(checkboxes).some((cb) => cb.checked)
    ) {
      updateResultsCount(allProducts.length);
    }
  }

  function getActiveFilters() {
    const filters = {};

    checkboxes.forEach((cb) => {
      if (cb.checked) {
        const prefix = cb.dataset.prefix;
        const tag = cb.dataset.tag;

        if (!filters[prefix]) {
          filters[prefix] = [];
        }

        filters[prefix].push(tag);
      }
    });

    return filters;
  }

function hasActiveFilters(
  filters,
  searchTerm,
  inStockOnly,
  minPrice,
  maxPrice,
  defaultMinPrice,
  defaultMaxPrice,
  sortValue
) {
  const hasPriceFilter = minPrice > defaultMinPrice || maxPrice < defaultMaxPrice;
  const hasSort = sortValue && sortValue !== "featured";

  return (
    Object.keys(filters).length > 0 ||
    searchTerm.length > 0 ||
    inStockOnly ||
    hasPriceFilter ||
    hasSort
  );
}

  function productMatches(product, filters, searchTerm, inStockOnly, minPrice, maxPrice) {
    for (const prefix in filters) {
      const selectedTagsInGroup = filters[prefix];
      const groupMatch = selectedTagsInGroup.some((tag) => product.tags.includes(tag));

      if (!groupMatch) return false;
    }

    if (searchTerm) {
      const title = (product.title || "").toLowerCase();
      if (!title.includes(searchTerm)) return false;
    }

    if (inStockOnly && !product.available) {
      return false;
    }

    if (product.variantPrices.length) {
      const hasValidPrice = product.variantPrices.some(
        (price) => price >= minPrice && price <= maxPrice
      );

      if (!hasValidPrice) return false;
    }

    return true;
  }

  function refreshRenderedContent() {
    window.dispatchEvent(new Event("resize"));
    window.dispatchEvent(new Event("scroll"));

    const lazyImages = document.querySelectorAll('img[loading="lazy"], img[data-src], img[data-srcset]');
    lazyImages.forEach((img) => {
      img.loading = "eager";
      if (img.dataset.src && !img.src) img.src = img.dataset.src;
      if (img.dataset.srcset && !img.srcset) img.srcset = img.dataset.srcset;
    });
  }

  function renderProducts(products) {
    gridContainer.innerHTML = products.map((product) => product.html).join("");

    requestAnimationFrame(() => {
      refreshRenderedContent();
    });
  }

function renderActiveFilterChips(filters, searchTerm, inStockOnly, minPrice, maxPrice) {
  if (!activeFiltersContainer) return;

  const chips = [];

/* Add Clear All chip if filters exist */

const hasAnyFilters =
  Object.keys(filters).length ||
  searchTerm ||
  inStockOnly ||
  (minPrice > defaultMinPrice || maxPrice < defaultMaxPrice);

if (hasAnyFilters) {
  chips.push(`
    <button
      type="button"
      class="sp-active-filter-chip sp-clear-all-chip"
      data-chip-type="clear-all"
    >
      <span>Clear All</span>
      <span class="sp-active-filter-chip-remove">×</span>
    </button>
  `);
}

  for (const prefix in filters) {
    filters[prefix].forEach((tag) => {
      const label = tag.replace(prefix, "");
      chips.push(`
        <button
          type="button"
          class="sp-active-filter-chip"
          data-chip-type="tag"
          data-prefix="${prefix}"
          data-tag="${tag}"
        >
          <span>${label}</span>
          <span class="sp-active-filter-chip-remove">×</span>
        </button>
      `);
    });
  }

  if (searchTerm) {
    chips.push(`
      <button type="button" class="sp-active-filter-chip" data-chip-type="search">
        <span>Search: ${searchTerm}</span>
        <span class="sp-active-filter-chip-remove">×</span>
      </button>
    `);
  }

  if (inStockOnly) {
    chips.push(`
      <button type="button" class="sp-active-filter-chip" data-chip-type="stock">
        <span>In Stock</span>
        <span class="sp-active-filter-chip-remove">×</span>
      </button>
    `);
  }

  const priceChanged = minPrice > defaultMinPrice || maxPrice < defaultMaxPrice;
  if (priceChanged) {
    chips.push(`
      <button type="button" class="sp-active-filter-chip" data-chip-type="price">
        <span>$${minPrice} - $${maxPrice}</span>
        <span class="sp-active-filter-chip-remove">×</span>
      </button>
    `);
  }

  activeFiltersContainer.innerHTML = chips.join("");
  activeFiltersContainer.style.display = chips.length ? "flex" : "none";

  activeFiltersContainer.querySelectorAll(".sp-active-filter-chip").forEach((chip) => {
    chip.addEventListener("click", function () {
      const type = chip.dataset.chipType;
if (type === "clear-all") {

  checkboxes.forEach((cb) => {
    cb.checked = false;
  });

  if (searchInput) searchInput.value = "";

  if (inStockCheckbox) inStockCheckbox.checked = false;

  if (priceMinRange) priceMinRange.value = defaultMinPrice;
  if (priceMaxRange) priceMaxRange.value = defaultMaxPrice;

  if (priceMinInput) priceMinInput.value = defaultMinPrice;
  if (priceMaxInput) priceMaxInput.value = defaultMaxPrice;

  updatePriceProgress();
}
      if (type === "tag") {
        const tag = chip.dataset.tag;
        checkboxes.forEach((cb) => {
          if (cb.dataset.tag === tag) cb.checked = false;
        });
      }

      if (type === "search" && searchInput) {
        searchInput.value = "";
      }

      if (type === "stock" && inStockCheckbox) {
        inStockCheckbox.checked = false;
      }

      if (type === "price") {
        if (priceMinRange) priceMinRange.value = defaultMinPrice;
        if (priceMaxRange) priceMaxRange.value = defaultMaxPrice;
        if (priceMinInput) priceMinInput.value = defaultMinPrice;
        if (priceMaxInput) priceMaxInput.value = defaultMaxPrice;
        updatePriceProgress();
      }

      applyFilters();
    });
  });
}

function sortProducts(products, sortValue) {
  const sorted = [...products];

  if (sortValue === "price-asc") {
    sorted.sort((a, b) => {
      const aPrice = a.variantPrices.length ? Math.min(...a.variantPrices) : 0;
      const bPrice = b.variantPrices.length ? Math.min(...b.variantPrices) : 0;
      return aPrice - bPrice;
    });
  }

  if (sortValue === "price-desc") {
    sorted.sort((a, b) => {
      const aPrice = a.variantPrices.length ? Math.max(...a.variantPrices) : 0;
      const bPrice = b.variantPrices.length ? Math.max(...b.variantPrices) : 0;
      return bPrice - aPrice;
    });
  }

  if (sortValue === "title-asc") {
    sorted.sort((a, b) => a.title.localeCompare(b.title));
  }

  if (sortValue === "title-desc") {
    sorted.sort((a, b) => b.title.localeCompare(a.title));
  }

  return sorted;
}

  function applyFilters() {
    const filters = getActiveFilters();
    const searchTerm = searchInput ? searchInput.value.trim().toLowerCase() : "";
    const inStockOnly = inStockCheckbox ? inStockCheckbox.checked : false;
    const minPrice = priceMinInput ? parseFloat(priceMinInput.value || 0) : 0;
    const maxPrice = priceMaxInput ? parseFloat(priceMaxInput.value || 999999) : 999999;
    const sortValue = sortSelect ? sortSelect.value : "featured";

    updatePriceProgress();

const active = hasActiveFilters(
  filters,
  searchTerm,
  inStockOnly,
  minPrice,
  maxPrice,
  defaultMinPrice,
  defaultMaxPrice,
  sortValue
);

    if (!active) {
      gridContainer.innerHTML = originalGridHTML;

      if (pagination) pagination.style.display = "";
      if (noProductsMessage) {
        noProductsMessage.style.display = "none";
        noProductsMessage.textContent = "No matching products found.";
      }

renderActiveFilterChips(filters, searchTerm, inStockOnly, minPrice, maxPrice);

      updateResultsCount(
        allProductsLoaded
          ? allProducts.length
          : document.querySelectorAll(".product-card-wrapper").length
      );

      requestAnimationFrame(() => {
        refreshRenderedContent();
      });

      return;
    }

    if (!allProductsLoaded) {
      if (noProductsMessage) {
        noProductsMessage.style.display = "block";
        noProductsMessage.textContent = "Loading matching products...";
      }

      if (pagination) pagination.style.display = "none";
      return;
    }

    let matched = allProducts.filter((product) =>
  productMatches(product, filters, searchTerm, inStockOnly, minPrice, maxPrice)
);

matched = sortProducts(matched, sortValue);

renderProducts(matched);
updateResultsCount(matched.length);

    if (pagination) pagination.style.display = "none";

    if (noProductsMessage) {
      if (matched.length === 0) {
        noProductsMessage.style.display = "block";
        noProductsMessage.textContent = "No matching products found.";
      } else {
        noProductsMessage.style.display = "none";
      }
    }
      /* THIS WAS MISSING — VERY IMPORTANT */
  renderActiveFilterChips(
    filters,
    searchTerm,
    inStockOnly,
    minPrice,
    maxPrice
  );

  }

  checkboxes.forEach((cb) => {
    cb.addEventListener("change", applyFilters);
  });

  if (searchInput) {
    searchInput.addEventListener("input", applyFilters);
  }

  if (inStockCheckbox) {
    inStockCheckbox.addEventListener("change", applyFilters);
  }

if (sortSelect) {
  sortSelect.addEventListener("change", applyFilters);
}

  if (clearFiltersButton) {
    clearFiltersButton.addEventListener("click", function () {
      checkboxes.forEach((cb) => {
        cb.checked = false;
      });

      if (searchInput) {
        searchInput.value = "";
      }

      if (inStockCheckbox) {
        inStockCheckbox.checked = false;
      }

      if (priceMinRange) {
        priceMinRange.value = defaultMinPrice;
      }

      if (priceMaxRange) {
        priceMaxRange.value = defaultMaxPrice;
      }

      if (priceMinInput) {
        priceMinInput.value = defaultMinPrice;
      }

      if (priceMaxInput) {
        priceMaxInput.value = defaultMaxPrice;
      }

      updatePriceProgress();
      applyFilters();
    });
  }

  document.querySelectorAll(".sp-tag-filters__group").forEach((group) => {
    const items = group.querySelectorAll(".sp-tag-filters__item");

    if (items.length <= 5) return;

    items.forEach((item, index) => {
      if (index >= 5) {
        item.classList.add("sp-filter-hidden");
      }
    });

    const toggle = document.createElement("span");
    toggle.className = "sp-filter-show-toggle";
    toggle.textContent = "Show More +";

    let expanded = false;

    toggle.addEventListener("click", () => {
      expanded = !expanded;

      items.forEach((item, index) => {
        if (index >= 5) {
          if (expanded) {
            item.classList.remove("sp-filter-hidden");
          } else {
            item.classList.add("sp-filter-hidden");
          }
        }
      });

      toggle.textContent = expanded ? "Show Less -" : "Show More +";
    });

    group.appendChild(toggle);
  });

  if (priceMinRange && priceMinInput && priceMaxRange && priceMaxInput) {
    priceMinRange.addEventListener("input", function () {
      let minVal = parseFloat(priceMinRange.value);
      let maxVal = parseFloat(priceMaxRange.value);

      if (minVal > maxVal) {
        minVal = maxVal;
        priceMinRange.value = minVal;
      }

      priceMinInput.value = minVal;
      updatePriceProgress();
      applyFilters();
    });

    priceMaxRange.addEventListener("input", function () {
      let minVal = parseFloat(priceMinRange.value);
      let maxVal = parseFloat(priceMaxRange.value);

      if (maxVal < minVal) {
        maxVal = minVal;
        priceMaxRange.value = maxVal;
      }

      priceMaxInput.value = maxVal;
      updatePriceProgress();
      applyFilters();
    });

    priceMinInput.addEventListener("input", function () {
      let minVal = parseFloat(priceMinInput.value || defaultMinPrice);
      let maxVal = parseFloat(priceMaxInput.value || defaultMaxPrice);

      if (minVal < defaultMinPrice) minVal = defaultMinPrice;
      if (minVal > maxVal) minVal = maxVal;

      priceMinInput.value = minVal;
      priceMinRange.value = minVal;
      updatePriceProgress();
      applyFilters();
    });

    priceMaxInput.addEventListener("input", function () {
      let minVal = parseFloat(priceMinInput.value || defaultMinPrice);
      let maxVal = parseFloat(priceMaxInput.value || defaultMaxPrice);

      if (maxVal > defaultMaxPrice) maxVal = defaultMaxPrice;
      if (maxVal < minVal) maxVal = minVal;

      priceMaxInput.value = maxVal;
      priceMaxRange.value = maxVal;
      updatePriceProgress();
      applyFilters();
    });
  }

  loadAllProducts();
});